import WeatherDetailed from './weather-detailed'
export default WeatherDetailed
